import { Component, EventEmitter, inject, Injector, Input, Output } from '@angular/core';
import { runInInjectionContext } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SessionService } from '../../services';
import { CONSTANTS_TOKEN } from '../../config';
import { LocalStorage } from '../../enums';

@Component({
  selector: 'educare-navigation',
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  imports: [RouterModule, TranslateModule, CommonModule]
})
export class NavigationComponent {
  private readonly sessionService = inject(SessionService);
  private readonly injector = inject(Injector);
  private readonly config = inject(CONSTANTS_TOKEN);
  @Input() isCollapsed = false; // <-- receives Home sidebar state
  @Output() expandRequested = new EventEmitter<void>(); // <-- tells Home to expand
  activeSubMenu: string | null = null;
  links: any = this.config.shared.navigation;
  category: string = '';

  constructor() {
    this.getUserCategory();
  }

  getUserCategory() {
    const userInfo: any = this.sessionService.getItem(LocalStorage.UserInfo);
    this.category = userInfo.user?.category?.category?.toString();
  }

  toggleSubMenu(tabKey: string, link?: any): void {
    // If sidebar is collapsed, expand it first so submenu can render normally
    if (this.isCollapsed) {
      this.expandRequested.emit();
    }

    if (link?.onClick) {
      runInInjectionContext(this.injector, () => {
        const clickHandler = link.onClick();
        clickHandler();
      });
      return;
    }

    this.activeSubMenu = this.activeSubMenu === tabKey ? null : tabKey;
  }

  isSubMenuOpen(tabKey: string): boolean {
    return this.activeSubMenu === tabKey;
  }

  // Optional: if user clicks a sub-link while collapsed, expand too
  onSubLinkClick(): void {
    if (this.isCollapsed) this.expandRequested.emit();
  }
}
